import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatefulComponent } from '../../components/stateful/stateful.component';
import { setContainerTypeAction } from '../../ngrx/actions/global.actions';
import { ContactFormComponent } from '../../components/contact-form/contact-form.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  standalone: true,
  imports: [CommonModule, ContactFormComponent]
})
export class ContactUsComponent extends StatefulComponent implements OnInit {
  phone = '+14073500316';
  displayPhone = '(407) 350-0316';
  address = '69 Oak Tree Drive, Chelsea, AL 35043';

  ngOnInit() {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
  }
}
